import React from 'react'
import PropTypes from 'prop-types'
import Input from 'client/components/core/Sidebar/components/Settings/components/Input'

const Width = ({ width = 0, update }) => (
  <Input
    update={update}
    value={+width}
    placeholder={'PX'}
    labelText="width"
    type="number"
  />
)

Width.propTypes = {
  update: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Width
